import React, {useState, useRef, useEffect} from 'react';
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {TestModeDialogFC} from "@/app/(test)/UI/TestModeDialog/TestModeDialogFC";
import {ShopDialogFC} from "@/app/(pages)/store/ShopDialogFC";
interface TestBtnEnterProps {
    info?: string;
}

const TestBtnEnter: React.FC<TestBtnEnterProps> = (props) => {
    const {info} = props;
    const onClickBack = () => {
        SDialogManagerFC.openDialog(TestModeDialogFC,{
            fcKey:SDialogManagerFC.getFCKey(ShopDialogFC),
            onClose:()=>{

            }
        })
    }
    return (
        <div
            className={`btn TestBtn center`}
            onClick={onClickBack}
            style={{
                position: 'fixed',
                top: '1.5rem',
                right: '1.5rem',
                zIndex: 99999999,
                background: 'rgba(0, 0, 0, 0.8)',
                color: '#fff',
                fontSize: '0.4rem',
                width: '1rem',
                height: '1rem',
                textAlign: 'center',
                boxShadow: '1px 0 20px 2px rgb(255 255 255 / 50%)',
                borderRadius: '50%'
        }}>
            Test
        </div>
    );
};

export default TestBtnEnter;
